import { api } from '@/lib/api';
import type { PartType } from './types';
import type { PartTypeCreateValues, PartTypeUpdateValues } from './schema';

/**
 * Part-types REST client over the shared axios instance.
 *
 * Endpoints (Phase 4a):
 *   GET    /part-types        list
 *   GET    /part-types/:id    detail
 *   POST   /part-types        create
 *   PATCH  /part-types/:id    update (name/copy/flags only)
 *   DELETE /part-types/:id    soft-delete
 */
export const partTypesApi = {
  list: async (): Promise<PartType[]> => {
    const { data } = await api.get<PartType[]>('/part-types');
    return data;
  },

  getById: async (id: string): Promise<PartType> => {
    const { data } = await api.get<PartType>(`/part-types/${id}`);
    return data;
  },

  create: async (input: PartTypeCreateValues): Promise<PartType> => {
    const { data } = await api.post<PartType>('/part-types', input);
    return data;
  },

  update: async (
    id: string,
    patch: PartTypeUpdateValues,
  ): Promise<PartType> => {
    const { data } = await api.patch<PartType>(`/part-types/${id}`, patch);
    return data;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/part-types/${id}`);
  },
};
